import React, { useState } from "react";
import { MapPin, Calendar } from "lucide-react";
import MediaLightbox from "./MediaLightbox";

const ARCHIVE_BG =
  "https://static.prod-images.emergentagent.com/jobs/bbfc07bf-2800-4985-a925-f82e43e5cbf9/images/772dbd6d5f74f34a0e42780629b43298d30becfc3e082c9c3f8d70a62feb3869.png";

const CONCERTS = [
  {
    venue: "Schullerwald parkerdő",
    city: "Beszterce",
    date: "2026.06.14",
    image:
      "https://customer-assets-agu9un31.emergentagent.net/job_charge-charlie-band/artifacts/blu27d6c_474.webp",
  },
  {
    venue: "Liget-pavilon",
    city: "Túrkeve",
    date: "2024.09.07",
    image:
      "https://customer-assets.emergentagent.com/job_charge-charlie-band/artifacts/0hkq244g_turkeve.jpg",
  },
  {
    venue: "Főtér",
    city: "Heves",
    date: "2024.08.20",
    image:
      "https://customer-assets.emergentagent.com/job_charge-charlie-band/artifacts/70fo324o_tukeve_eredeti.jpg",
  },
  {
    venue: "Városliget",
    city: "Ibrány",
    date: "2024.08.19",
    image:
      "https://customer-assets.emergentagent.com/job_charge-charlie-band/artifacts/jhonar8t_ibrany.jpg",
  },
  {
    venue: "SarudiNyár",
    city: "Sarud",
    date: "2021.08.08",
    image:
      "https://customer-assets.emergentagent.com/job_charge-charlie-band/artifacts/oqy1ga52_sarudi.webp",
  },
  {
    venue: "Lecsófesztivál",
    city: "Gyömrő",
    date: "2018.09.02",
    image:
      "https://customer-assets.emergentagent.com/job_charge-charlie-band/artifacts/6gzqsayx_gyomroi.webp",
  },
];

export const Archive = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const lightboxItems = CONCERTS.map((c) => ({
    src: c.image,
    caption: `${c.venue} — ${c.city}`,
    subcaption: c.date,
  }));

  const openLightbox = (i) => {
    setLightboxIndex(i);
    setLightboxOpen(true);
  };

  return (
    <section
      id="archivum"
      className="relative w-full py-24 md:py-32 px-6 md:px-12 lg:px-20 overflow-hidden"
      data-testid="archive-section"
    >
      {/* BG */}
      <div
        className="absolute inset-0 bg-cover bg-center opacity-30"
        style={{ backgroundImage: `url(${ARCHIVE_BG})` }}
        aria-hidden="true"
      />
      <div
        className="absolute inset-0 bg-gradient-to-b from-[#050505] via-[#050505]/95 to-[#050505]"
        aria-hidden="true"
      />

      <div className="relative max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16">
          <div>
            <p className="font-display text-xs tracking-[0.4em] uppercase text-[#7000FF] mb-6">
              // 03 — Korábbi koncertek
            </p>
            <h2 className="font-display font-bold tracking-tighter text-white text-4xl sm:text-5xl lg:text-6xl">
              Archívum
            </h2>
          </div>
          <p className="font-body text-white/50 max-w-sm mt-6 md:mt-0 md:text-right">
            Pillanatok színpadról és színpad mögül. Minden fellépés egy új
            történet.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {CONCERTS.map((c, i) => (
            <figure
              key={`${c.venue}-${i}`}
              data-testid="archive-photo"
              className="group relative overflow-hidden bg-[#0A0A0A] border border-white/10 hover:border-[#00E5FF]/40 transition-colors"
            >
              <button
                type="button"
                onClick={() => openLightbox(i)}
                aria-label={`${c.venue}, ${c.city} koncertkép megtekintése`}
                data-testid={`archive-image-button-${i}`}
                className="block w-full text-left cursor-zoom-in"
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={c.image}
                    alt={`${c.venue} - ${c.city} koncert`}
                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                    loading="lazy"
                  />
                  <div
                    className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/40 to-transparent"
                    aria-hidden="true"
                  />
                </div>
              </button>
              <figcaption className="relative p-5 border-t border-white/10">
                <div className="flex items-center gap-2 text-[#00E5FF] mb-2">
                  <MapPin className="h-3.5 w-3.5" />
                  <span className="font-display text-[0.65rem] uppercase tracking-[0.25em]">
                    Helyszín
                  </span>
                </div>
                <h3 className="font-display text-xl font-bold text-white">
                  {c.venue}
                </h3>
                <div className="flex items-center justify-between mt-3 text-sm">
                  <span className="text-white/70">{c.city}</span>
                  <span className="flex items-center gap-1.5 text-white/40 text-xs">
                    <Calendar className="h-3 w-3" />
                    {c.date}
                  </span>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>

      <MediaLightbox
        open={lightboxOpen}
        onOpenChange={setLightboxOpen}
        items={lightboxItems}
        index={lightboxIndex}
        setIndex={setLightboxIndex}
      />
    </section>
  );
};

export default Archive;
